module.exports = __webpack_public_path__ + "img/check.09c4d563.svg";